"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2870],{

/***/ 8009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CD": function() { return /* binding */ EXPIRED_GUIDE_MODE; },
/* harmony export */   "Sf": function() { return /* binding */ EXPIRED_GUIDE_SEVERE_EXCLUDED_PATHS; },
/* harmony export */   "UU": function() { return /* binding */ EXPIRED_PURCHASE_PATH; },
/* harmony export */   "h7": function() { return /* binding */ EXPIRED_GUIDE_DETAIL_EXCLUDED_PATHS; },
/* harmony export */   "jp": function() { return /* binding */ resolveDashboardPathByMode; }
/* harmony export */ });
/* unused harmony export EXPIRED_GUIDE_DASHBOARD_PATHS */
const EXPIRED_GUIDE_MODE = {
    NONE: "none",
    GRACE: "grace",
    SEVERE: "severe"
};
/** 全部设备过期超 30 天且无有效未绑单时的独立续费页（禁止进设备 dashboard） */ const EXPIRED_PURCHASE_PATH = "/expired-purchase";
/** 详情页不展示宽限期遮罩的路径 */ const EXPIRED_GUIDE_DETAIL_EXCLUDED_PATHS = [
    "/dashboard",
    "/android/dashboard",
    "/android/local/dashboard",
    "/pages/account-settings/account",
    "/android/local/permission-check",
    "/setup",
    "/android/classification",
    "/android/local/setup",
    "/android/setup",
    "/android/nodevice-setup",
    "/ios/setup",
    "/ios/extreme-verification",
    "/guide",
    "/settings",
    "/expired-purchase"
];
/** 全屏严重过期引导也不展示的路径（引导/设置流程） */ const EXPIRED_GUIDE_SEVERE_EXCLUDED_PATHS = [
    "/setup",
    "/android/classification",
    "/android/local/setup",
    "/android/setup",
    "/android/nodevice-setup",
    "/ios/setup",
    "/ios/extreme-verification",
    "/guide",
    "/settings"
];
const EXPIRED_GUIDE_DASHBOARD_PATHS = (/* unused pure expression or super */ null && ([
    "/dashboard",
    "/android/dashboard",
    "/android/local/dashboard"
]));
const resolveDashboardPathByMode = (mode)=>{
    if (mode === "Android-Cloud") return "/android/dashboard";
    if (mode === "Android-Local") return "/android/local/dashboard";
    return "/dashboard";
};


/***/ }),

/***/ 99518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ey": function() { return /* binding */ redirectToChooseDevice; },
/* harmony export */   "fs": function() { return /* binding */ redirectGuideAddNewDevice; },
/* harmony export */   "og": function() { return /* binding */ redirectIfShouldBuyPackage; },
/* harmony export */   "tA": function() { return /* binding */ filterValidUnboundOrders; }
/* harmony export */ });
/* unused harmony export shouldRedirectToBuyPackage */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_utils_navigate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48551);
/* harmony import */ var src_components_expired_purchase_guide_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8009);
/* harmony import */ var src_utils_userEntryGate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1128);




/** 与 web `appBridge` 桥接参数对齐（App 跳转购买时透传） */ const BRIDGE_QUERY_KEYS = [
    "from_app",
    "app_platform",
    "anonymous_user_id",
    "app_session_id",
    "web_bridge_id",
    "source_screen",
    "cta_name",
    "feature_id",
    "feature_name",
    "installid",
    "idfa",
    "ver",
    "agent"
];
/** 未过期、可绑定的未绑单（与跳转选购页判定一致） */ const filterValidUnboundOrders = (list)=>{
    const orders = Array.isArray(list) ? list : [];
    const now = Date.now();
    return orders.filter((item)=>{
        const expireTime = (item === null || item === void 0 ? void 0 : item.expire_time) ? new Date(item.expire_time).getTime() : 0;
        return Number.isFinite(expireTime) && expireTime >= now;
    });
};
/** 无有效未绑定订单（空列表或全部过期） */ const shouldRedirectToBuyPackage = (list)=>filterValidUnboundOrders(list).length === 0;
const isFromAppClient = ()=>{
    if (false) {}
    try {
        if (new URLSearchParams(window.location.search).get("from_app") === "1") return true;
        if (localStorage.getItem("installid")) return true;
        const bridge = JSON.parse(sessionStorage.getItem("spyx_web_app_bridge") || "null");
        if ((bridge === null || bridge === void 0 ? void 0 : bridge.from_app) === "1") return true;
    } catch (e) {
    // ignore
    }
    return false;
};
const buildClientBuyPath = ()=>{
    const token = localStorage.getItem("accessToken");
    const fromApp = isFromAppClient();
    const params = new URLSearchParams();
    if (token) params.set("token", token);
    // Msafely web 未迁 SpyX 的 /step/*；对齐 dashboard main 的官网路径
    if (fromApp) {
        params.set("from_app", "1");
        try {
            const current = new URLSearchParams(window.location.search);
            BRIDGE_QUERY_KEYS.forEach((key)=>{
                const value = current.get(key);
                if (value) params.set(key, value);
            });
        } catch (e) {
        // ignore
        }
        const qs = params.toString();
        const pricingPath = "/pricing" || 0;
        return "".concat(pricingPath).concat(qs ? "?".concat(qs) : "");
    }
    const qs1 = params.toString();
    return "/choose-monitored-device".concat(qs1 ? "?".concat(qs1) : "");
};
/** 去购买：对齐 Msafely main → /choose-monitored-device；App → /pricing */ const redirectToChooseDevice = ()=>{
    const clientUrl = "https://test-ms-web.gbyte.com.cn" || 0;
    (0,src_utils_navigate__WEBPACK_IMPORTED_MODULE_1__/* .navigateTo */ .T8)("".concat(clientUrl).concat(buildClientBuyPath()));
};
/**
 * Guide 顶栏「Add New Device」：
 * 已有套餐（已绑设备或有效未绑单）→ Dashboard；否则 → 官网 /choose-monitored-device
 */ const redirectGuideAddNewDevice = async ()=>{
    try {
        const { getAllUserDevice , getNotBindOrder  } = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 53399));
        const [devicesRes, ordersRes] = await Promise.all([
            getAllUserDevice({}).catch(()=>({
                    data: []
                })),
            getNotBindOrder({}).catch(()=>({
                    data: []
                }))
        ]);
        const devices = Array.isArray(devicesRes === null || devicesRes === void 0 ? void 0 : devicesRes.data) ? devicesRes.data : [];
        const hasValidUnboundOrders = filterValidUnboundOrders(ordersRes === null || ordersRes === void 0 ? void 0 : ordersRes.data).length > 0;
        if (devices.length > 0 || hasValidUnboundOrders) {
            next_router__WEBPACK_IMPORTED_MODULE_0___default().push("/dashboard");
            return;
        }
    } catch (error) {
        ;
    }
    redirectToChooseDevice();
};
/**
 * setup 类页面的兜底：没有有效未绑单时离开绑定流程。
 * 优先级由 userEntryGate 统一裁决：全部订单过期超 30 天 → 过期页，其余 → 去购买。
 * 已有有效未绑单则原地留在绑定流程。
 * @returns {Promise<boolean>} 是否已发生跳转
 */ const redirectIfShouldBuyPackage = async (orderResult)=>{
    const list = (orderResult === null || orderResult === void 0 ? void 0 : orderResult.data) || [];
    const validUnbound = filterValidUnboundOrders(list);
    if (validUnbound.length > 0) return false;
    const flags = await (0,src_utils_userEntryGate__WEBPACK_IMPORTED_MODULE_3__/* .loadUserEntryFlags */ .lf)();
    const entryType = (0,src_utils_userEntryGate__WEBPACK_IMPORTED_MODULE_3__/* .resolveUserEntry */ .Ji)({
        flags,
        validUnboundOrders: validUnbound
    });
    if (entryType === src_utils_userEntryGate__WEBPACK_IMPORTED_MODULE_3__/* .USER_ENTRY.EXPIRED */ .Tv.EXPIRED) {
        window.location.assign(src_components_expired_purchase_guide_constants__WEBPACK_IMPORTED_MODULE_2__/* .EXPIRED_PURCHASE_PATH */ .UU);
        return true;
    }
    redirectToChooseDevice();
    return true;
};


/***/ }),

/***/ 32870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ clearBindOrderContext; },
/* harmony export */   "Bq": function() { return /* binding */ guardAppSetupOrderId; },
/* harmony export */   "Ef": function() { return /* binding */ cacheBindOrder; },
/* harmony export */   "G4": function() { return /* binding */ readCachedBindOrderId; },
/* harmony export */   "Gp": function() { return /* binding */ selectUnboundPackage; },
/* harmony export */   "O7": function() { return /* binding */ resolveBindOrderIdWithFeedback; },
/* harmony export */   "Rb": function() { return /* binding */ appendSetupQuery; },
/* harmony export */   "Sj": function() { return /* binding */ ensureBindOrderContext; },
/* harmony export */   "gJ": function() { return /* binding */ isUnboundPackageSelectionActive; }
/* harmony export */ });
/* unused harmony exports persistBindOrderIdFromSearch, syncOrderIdToUrl, isFromAppSession */
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29143);
/* harmony import */ var src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99518);
/* harmony import */ var src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83989);




const BIND_ORDER_STORAGE_KEY = "ontBindOrder";
const FROM_APP_STORAGE_KEY = "spyx_from_app";
const MISSING_ORDER_MSG = "Current order is missing";
const readSearchParams = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    try {
        const raw = String(search || "");
        const query = raw.startsWith("?") ? raw.slice(1) : raw;
        if (!query) return new URLSearchParams();
        return new URLSearchParams(query);
    } catch (e) {
        return new URLSearchParams();
    }
};
const readOrderIdFromSearch = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    try {
        const params = readSearchParams(search);
        const orderId = params.get("orderId") || params.get("order_id");
        return orderId ? String(orderId) : null;
    } catch (e) {
        return null;
    }
};
/** URL 带 orderId 时写入 ontBindOrder；App 会话标记 from_app */ const persistBindOrderIdFromSearch = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] :  true ? window.location.search : 0;
    if (false) {}
    const params = readSearchParams(search);
    if (params.get("from_app") === "1") {
        localStorage.setItem(FROM_APP_STORAGE_KEY, "1");
    }
    const orderId = readOrderIdFromSearch(search);
    if (!orderId) return null;
    try {
        const prev = JSON.parse(localStorage.getItem(BIND_ORDER_STORAGE_KEY) || "null");
        if (prev && typeof prev === "object" && String(prev.id) === String(orderId)) {
            return orderId;
        }
    } catch (e) {
    // ignore invalid cache
    }
    localStorage.setItem(BIND_ORDER_STORAGE_KEY, JSON.stringify({
        id: orderId
    }));
    return orderId;
};
const readCachedBindOrderId = ()=>{
    if (false) {}
    try {
        const ontBindOrder = JSON.parse(localStorage.getItem(BIND_ORDER_STORAGE_KEY) || "null");
        return (ontBindOrder === null || ontBindOrder === void 0 ? void 0 : ontBindOrder.id) ? String(ontBindOrder.id) : null;
    } catch (e) {
        return null;
    }
};
/** 侧栏已选空 Package（有绑定单且无当前设备） */ const isUnboundPackageSelectionActive = ()=>{
    if (false) {}
    const orderId = readCachedBindOrderId();
    if (!orderId) return false;
    try {
        const deviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "{}") || {};
        const hasDevice = deviceUser.device_id != null && String(deviceUser.device_id) !== "" || deviceUser.username != null && String(deviceUser.username) !== "";
        return !hasDevice;
    } catch (e) {
        return true;
    }
};
/** 清除绑定单缓存与 URL 上的 orderId（已绑完 / 失效时用） */ const clearBindOrderContext = ()=>{
    if (false) {}
    try {
        localStorage.removeItem(BIND_ORDER_STORAGE_KEY);
    } catch (e) {
    // ignore
    }
    try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has("orderId") && !url.searchParams.has("order_id")) return;
        url.searchParams.delete("orderId");
        url.searchParams.delete("order_id");
        window.history.replaceState(window.history.state, "", url.toString());
    } catch (e1) {
    // ignore
    }
};
const getBindOrderId = (order)=>{
    var ref;
    const id = (ref = order === null || order === void 0 ? void 0 : order.id) !== null && ref !== void 0 ? ref : order === null || order === void 0 ? void 0 : order.order_id;
    return id != null && id !== "" ? String(id) : null;
};
/** 用户选中套餐后写入 ontBindOrder */ const cacheBindOrder = (order)=>{
    if (false) {}
    const id = getBindOrderId(order);
    if (!id) return null;
    localStorage.setItem(BIND_ORDER_STORAGE_KEY, JSON.stringify({
        ...order,
        id
    }));
    return id;
};
/**
 * 侧栏选中空 Package：写入绑定单、清空当前设备选中并广播切换。
 * 使 Redux / localStorage 与 UI 高亮一致，不再保留上一个已绑定设备。
 */ const selectUnboundPackage = (param)=>{
    let { dispatch , order  } = param;
    const orderId = cacheBindOrder(order);
    if (!orderId) return null;
    syncOrderIdToUrl(orderId);
    (0,src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_3__/* .switchDevice */ .m)({
        dispatch,
        deviceUser: {},
        currentDevice: {}
    });
    return orderId;
};
/** 无刷新把 orderId 同步到地址栏，避免刷新丢上下文 */ const syncOrderIdToUrl = (orderId)=>{
    if ( false || !orderId) return;
    try {
        const url = new URL(window.location.href);
        if (url.searchParams.get("orderId") === String(orderId)) return;
        url.searchParams.set("orderId", String(orderId));
        url.searchParams.delete("order_id");
        window.history.replaceState(window.history.state, "", url.toString());
    } catch (e) {
    // ignore
    }
};
const isFromAppSession = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] :  true ? window.location.search : 0;
    const params = readSearchParams(search);
    if (params.get("from_app") === "1") return true;
    if (false) {}
    return localStorage.getItem(FROM_APP_STORAGE_KEY) === "1";
};
/** 跳转 setup 子页时带上 orderId / from_app */ const appendSetupQuery = (path, orderId)=>{
    if (!path) return path;
    const resolvedOrderId = orderId || readOrderIdFromSearch( true ? window.location.search : 0) || readCachedBindOrderId();
    const fromApp = isFromAppSession( true ? window.location.search : 0);
    if (!resolvedOrderId && !fromApp) return path;
    try {
        const [pathnameAndQuery, hash = ""] = String(path).split("#");
        const qIndex = pathnameAndQuery.indexOf("?");
        const pathname = qIndex >= 0 ? pathnameAndQuery.slice(0, qIndex) : pathnameAndQuery;
        const existing = qIndex >= 0 ? pathnameAndQuery.slice(qIndex + 1) : "";
        const params = new URLSearchParams(existing);
        if (resolvedOrderId) {
            params.set("orderId", String(resolvedOrderId));
            params.delete("order_id");
        }
        if (fromApp) {
            params.set("from_app", "1");
        }
        const qs = params.toString();
        return "".concat(pathname).concat(qs ? "?".concat(qs) : "").concat(hash ? "#".concat(hash) : "");
    } catch (e) {
        return path;
    }
};
/** App 进 setup 必须有 orderId，否则拦截 */ const guardAppSetupOrderId = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] :  true ? window.location.search : 0;
    const params = readSearchParams(search);
    const queryOrderId = readOrderIdFromSearch(search);
    const fromAppInUrl = params.get("from_app") === "1";
    const fromApp = isFromAppSession(search);
    if (fromAppInUrl && !queryOrderId) {
        (0,src_components_Message__WEBPACK_IMPORTED_MODULE_1__/* .messageInfo */ .B)({
            content: MISSING_ORDER_MSG
        });
        return {
            ok: false,
            blocked: true,
            orderId: null,
            fromApp: true
        };
    }
    const persisted = persistBindOrderIdFromSearch(search);
    const orderId = persisted || queryOrderId || readCachedBindOrderId();
    if (fromApp && !orderId) {
        (0,src_components_Message__WEBPACK_IMPORTED_MODULE_1__/* .messageInfo */ .B)({
            content: MISSING_ORDER_MSG
        });
        return {
            ok: false,
            blocked: true,
            orderId: null,
            fromApp: true
        };
    }
    return {
        ok: true,
        blocked: false,
        orderId,
        fromApp
    };
};
let unboundOrdersInflight = null;
const loadUnboundOrders = async ()=>{
    if (unboundOrdersInflight) return unboundOrdersInflight;
    unboundOrdersInflight = (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getNotBindOrder)().then((res)=>{
        return Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
    }).finally(()=>{
        setTimeout(()=>{
            unboundOrdersInflight = null;
        }, 2000);
    });
    return unboundOrdersInflight;
};
/**
 * 从未绑单列表解析 orderId（购买 → 绑定主路径）
 * - 过滤过期单后仅 1 张有效未绑单：自动选中
 * - 多张有效单：优先侧栏已选缓存；setup 初始化时可 autoPickFirst 默认第一张
 */ const resolveFromUnboundOrders = function(unbound) {
    let { autoPickFirst =false  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const list = (0,src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_2__/* .filterValidUnboundOrders */ .tA)(unbound);
    if (list.length === 1) {
        return cacheBindOrder(list[0]);
    }
    if (list.length > 1) {
        const selected = readCachedBindOrderId();
        if (selected && list.some((item)=>getBindOrderId(item) === selected)) {
            return selected;
        }
        if (autoPickFirst) {
            return cacheBindOrder(list[0]);
        }
    }
    return null;
};
/**
 * setup 页初始化：同步 URL/cache；仅一张未绑单时自动挂上 orderId
 */ const ensureBindOrderContext = async function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] :  true ? window.location.search : 0;
    const guard = guardAppSetupOrderId(search);
    if (guard.blocked) {
        return {
            ...guard,
            needsOrderSelection: false
        };
    }
    let orderId = guard.orderId;
    let needsOrderSelection = false;
    if (!orderId) {
        try {
            const unbound = await loadUnboundOrders();
            orderId = resolveFromUnboundOrders(unbound, {
                autoPickFirst: true
            });
            if (orderId) {
                syncOrderIdToUrl(orderId);
            } else if ((0,src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_2__/* .filterValidUnboundOrders */ .tA)(unbound).length > 1) {
                needsOrderSelection = true;
            }
        } catch (e) {
            ;
        }
    } else {
        syncOrderIdToUrl(orderId);
    }
    return {
        ok: true,
        blocked: false,
        orderId,
        fromApp: guard.fromApp,
        needsOrderSelection
    };
};
/** Connect 点击时解析 orderId，失败则 toast */ const resolveBindOrderIdWithFeedback = async function(t) {
    let notify = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_components_Message__WEBPACK_IMPORTED_MODULE_1__/* .messageInfo */ .B;
    try {
        const orderId = await resolveCurrentOrderId();
        if (!orderId) {
            notify({
                content: (t === null || t === void 0 ? void 0 : t("Please select a package to bind first")) || MISSING_ORDER_MSG,
                type: "error"
            });
            return null;
        }
        return orderId;
    } catch (e) {
        notify({
            content: (t === null || t === void 0 ? void 0 : t("Network error, please try again")) || "Network error, please try again",
            type: "error"
        });
        return null;
    }
};
/**
 * 绑定 API 用的 order_id（字段名必须是 order_id，不是 orderId）
 * 优先级：显式传入 → URL/缓存 → 未绑单 → 已有设备/支付单号
 */ const resolveCurrentOrderId = async function() {
    let { order , orderId  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (orderId) return String(orderId);
    if (order === null || order === void 0 ? void 0 : order.id) return String(order.id);
    const fromUrl = persistBindOrderIdFromSearch( true ? window.location.search : 0);
    if (fromUrl) return fromUrl;
    const cached = readCachedBindOrderId();
    if (cached) return cached;
    try {
        const unbound = await loadUnboundOrders();
        const fromUnbound = resolveFromUnboundOrders(unbound, {
            autoPickFirst: true
        });
        if (fromUnbound) {
            syncOrderIdToUrl(fromUnbound);
            return fromUnbound;
        }
    } catch (e) {
        ;
        throw e;
    }
    let deviceUser = null;
    try {
        deviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "null");
    } catch (e1) {
    // ignore invalid DeviceUser
    }
    let orders = null;
    const loadAccountOrders = async ()=>{
        if (orders) return orders;
        const query = {
            page: 1,
            pageSize: 9999
        };
        try {
            const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getUserAccountOrder)(query);
            orders = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
            return orders;
        } catch (e) {
            ;
            throw e;
        }
    };
    // 已有设备重验：按 device_id 找关联订单
    if (deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.device_id) {
        const list = await loadAccountOrders();
        const byDevice = list.find((item)=>String(item.device_id) === String(deviceUser.device_id));
        if (byDevice === null || byDevice === void 0 ? void 0 : byDevice.id) return String(byDevice.id);
    }
    // 支付回调写入的 orderNo
    const orderNo = localStorage.getItem("orderNo");
    if (orderNo) {
        const list1 = await loadAccountOrders();
        const byMerchant = list1.find((item)=>String(item.merchant_no) === String(orderNo));
        if (byMerchant === null || byMerchant === void 0 ? void 0 : byMerchant.id) return String(byMerchant.id);
    }
    return null;
};
/* harmony default export */ __webpack_exports__["ZP"] = (resolveCurrentOrderId);


/***/ }),

/***/ 83989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ switchDevice; }
/* harmony export */ });
/* unused harmony export resolveDeviceUserId */
/* harmony import */ var src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38365);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34745);
/* harmony import */ var src_utils_deviceContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67778);



/** 切换设备时需清除的会话级 localStorage 缓存 */ const DEVICE_SCOPED_CACHE_KEYS = [
    "smsItem",
    "whatsappItem",
    "lineItem",
    "kikItem",
    "weChatItem",
    "MessengerItem",
    "messengerItem",
    "wechatItem",
    "waBusinessItem",
    "androidWhatsappItem"
];
/**
 * 从 DeviceUser 解析 Redux 选中键（优先 device_id，否则 username）。
 * @param {Object} [deviceUser]
 * @returns {string}
 */ const resolveDeviceUserId = (deviceUser)=>{
    if (!deviceUser) return "";
    return deviceUser.device_id != null && deviceUser.device_id !== "" ? String(deviceUser.device_id) : deviceUser.username || "";
};
/**
 * 统一设备切换入口：写 localStorage、清会话缓存、广播 deviceSwitched、刷新验证/连接状态。
 * 超 30 天失效设备禁止成为选中态。
 * @param {Object} params
 * @param {import('redux').Dispatch} params.dispatch
 * @param {Object} [params.deviceUser] - 写入 DeviceUser；undefined 时不覆盖
 * @param {Object} [params.currentDevice] - 写入 currentDevice；undefined 时不覆盖
 * @param {string} [params.currentMode] - 平台模式；缺省读 localStorage
 * @param {boolean} [params.skipSelectionGuard] - 仅清空/非选中场景跳过校验
 * @returns {ReturnType<import('src/utils/deviceContext').buildDeviceContext}|null}
 */ const switchDevice = (param)=>{
    let { dispatch , deviceUser , currentDevice , currentMode , skipSelectionGuard =false  } = param;
    const hasSelectionPayload = deviceUser !== undefined && deviceUser != null && typeof deviceUser === "object" && Object.keys(deviceUser).length > 0;
    if (!skipSelectionGuard && hasSelectionPayload) {
        const check = (0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_0__/* .validateDeviceSelection */ .dv)(deviceUser);
        if (!check.ok) {
            ;
            return null;
        }
    }
    const mode = currentMode !== undefined && currentMode !== null && currentMode !== "" ? currentMode : localStorage.getItem("currentMode") || "";
    // 先写 currentMode，再 dispatch，避免其它逻辑读到旧平台
    if (mode) {
        localStorage.setItem("currentMode", mode);
    }
    if (deviceUser !== undefined) {
        localStorage.setItem("DeviceUser", JSON.stringify(deviceUser));
    }
    if (currentDevice !== undefined) {
        localStorage.setItem("currentDevice", JSON.stringify(currentDevice));
    }
    DEVICE_SCOPED_CACHE_KEYS.forEach((key)=>localStorage.removeItem(key));
    const deviceId = resolveDeviceUserId(deviceUser);
    const storedDeviceUser = deviceUser !== undefined ? deviceUser : JSON.parse(localStorage.getItem("DeviceUser") || "{}");
    const storedCurrentDevice = currentDevice !== undefined ? currentDevice : JSON.parse(localStorage.getItem("currentDevice") || "{}");
    const deviceContext = (0,src_utils_deviceContext__WEBPACK_IMPORTED_MODULE_2__/* .buildDeviceContext */ .D$)({
        deviceUser: storedDeviceUser,
        currentDevice: storedCurrentDevice,
        currentMode: mode,
        switchToken: (0,src_utils_deviceContext__WEBPACK_IMPORTED_MODULE_2__/* .createSwitchToken */ .kb)()
    });
    localStorage.setItem("deviceContext", JSON.stringify(deviceContext));
    dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .deviceSwitched */ .ex)({
        deviceUserId: deviceId,
        currentMode: mode,
        deviceContext
    }));
    dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .fetchResetTime */ .NZ)());
    if (mode === "Android-Local") {
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .getConnectionStatus */ .Zp)());
    } else {
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .setConnectionStatus */ .bl)(false));
    }
    return deviceContext;
};


/***/ }),

/***/ 1128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": function() { return /* binding */ resolveUserEntry; },
/* harmony export */   "Tv": function() { return /* binding */ USER_ENTRY; },
/* harmony export */   "lf": function() { return /* binding */ loadUserEntryFlags; }
/* harmony export */ });
/* unused harmony exports readUserEntryFlags, clearUserEntryFlags */
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);
/* harmony import */ var src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38365);


/**
 * 进站入口判定。
 *
 * 后端 `user-device` 只返回「未过期，或过期不超过 30 天」的设备包，
 * 因此设备列表为空既可能是从没买过，也可能是所有包都过期超 30 天，
 * 前端无法再用「设备全部 lapsed」推断该不该进过期页。
 * 这里改为以后端状态为准，本地推算只作为接口不可用时的降级。
 *
 * 优先级固定：
 * 1. isBuy === false                    → 购买
 * 2. isBuy === true 且 valid === false  → 过期超 30 天页
 * 3. 其余                               → 设备 / 未绑单 / 绑定向导流程
 */ const USER_ENTRY = Object.freeze({
    BUY: "buy",
    EXPIRED: "expired",
    CONTINUE: "continue"
});
const readBoolean = (value)=>typeof value === "boolean" ? value : null;
let flagsCache = null;
let flagsLoading = null;
/**
 * 读取 isBuy / shouldShowExpiredPage。
 * - isBuy：是否付过费（存在已支付订单，或存在设备记录）
 * - shouldShowExpiredPage：由 /tsafely-order/valid 的 valid 取反，表示最新一笔已支付订单已过期超 30 天
 *
 * 任一请求失败时对应字段为 null，调用方回退到本地推算，
 * 避免把接口异常当成「没买过」而把老用户踢去购买页。
 * @returns {Promise<{ isBuy: boolean|null, shouldShowExpiredPage: boolean|null }>}
 */ const loadUserEntryFlags = async function() {
    let { forceRefresh =false  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!forceRefresh && flagsCache) return flagsCache;
    if (flagsLoading) return flagsLoading;
    flagsLoading = Promise.all([
        (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getUserIsBuy)().catch(()=>null),
        (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getUserHasValidOrder)().catch(()=>null)
    ]).then((param)=>{
        let [buyRes, validRes] = param;
        var ref, ref1;
        const hasValidOrder = readBoolean(validRes === null || validRes === void 0 ? void 0 : (ref = validRes.data) === null || ref === void 0 ? void 0 : ref.valid);
        flagsCache = {
            isBuy: readBoolean(buyRes === null || buyRes === void 0 ? void 0 : (ref1 = buyRes.data) === null || ref1 === void 0 ? void 0 : ref1.isBuy),
            shouldShowExpiredPage: hasValidOrder === null ? null : !hasValidOrder
        };
        return flagsCache;
    }).finally(()=>{
        flagsLoading = null;
    });
    return flagsLoading;
};
const readUserEntryFlags = ()=>flagsCache;
const clearUserEntryFlags = ()=>{
    flagsCache = null;
};
/**
 * 按固定优先级给出入口结论；后端状态拿不到时才用 devices / 未绑单本地推算。
 * @param {Object} params
 * @param {{ isBuy: boolean|null, shouldShowExpiredPage: boolean|null }} [params.flags]
 * @param {Array} [params.devices]
 * @param {Array} [params.validUnboundOrders]
 * @returns {'buy'|'expired'|'continue'}
 */ const resolveUserEntry = function() {
    let { flags , devices =[] , validUnboundOrders =[]  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const isBuy = (ref = flags === null || flags === void 0 ? void 0 : flags.isBuy) !== null && ref !== void 0 ? ref : null;
    var ref1;
    const shouldShowExpiredPage = (ref1 = flags === null || flags === void 0 ? void 0 : flags.shouldShowExpiredPage) !== null && ref1 !== void 0 ? ref1 : null;
    if (isBuy === false) return USER_ENTRY.BUY;
    if (isBuy === true && shouldShowExpiredPage === true) return USER_ENTRY.EXPIRED;
    // 降级：接口未返回或请求失败时，沿用本地「设备全部 lapsed 且无未绑单」的推算
    if (isBuy === null || shouldShowExpiredPage === null) {
        if ((0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_1__/* .shouldEnterExpiredPurchasePage */ .q6)({
            devices,
            validUnboundOrders
        })) return USER_ENTRY.EXPIRED;
    }
    return USER_ENTRY.CONTINUE;
};


/***/ })

}]);